import type { IHttpRequest, IHttpResponse } from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import { PostSessionPayloadDTO, PostSessionResponseDTO } from '../../dto';
import type { UpdateSessionOptions } from './update-session.types';

export function updateSession(
  baseUrl: string,
  payload: PostSessionPayloadDTO,
  options?: UpdateSessionOptions<PostSessionPayloadDTO>,
): Promise<IHttpResponse<PostSessionResponseDTO>> {
  const call = options?.httpCall ?? fetchBasedCall;

  const request: IHttpRequest<PostSessionPayloadDTO> = {
    url: `${baseUrl}/session/${payload.UserContext.SessionId}`,
    method: 'POST',
    body: payload,
    ...options?.requestOverride,
    schemas: {
      request: PostSessionPayloadDTO,
      response: PostSessionResponseDTO,
    },
  };

  return call(request);
}
